import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Dropdown, Form, Input } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { emailRegex } from '~/components/FormFields/constants'

interface LanguageFormProps {
  index: number,
  countriesCodes: any[],
  watchSupportStatus: number
}

const LanguageForm: React.FunctionComponent<LanguageFormProps> = (props) => {
  const { t } = useTranslation()
  const { control, setValue } = useFormContext()
  const { index, countriesCodes, watchSupportStatus } = props

  //refactor this
  //at least create and array of fields and assign to consts
  const watchPhoneCodeField = useWatch({ control, name: `support.languages[${index}].phoneCode` })
  const wathcMobileCodeField = useWatch({ control, name: `support.languages[${index}].faxCode` })
  const mobileNumber = useWatch({ control, name: `support.languages[${index}].faxNumber` })
  const phoneNumber = useWatch({ control, name: `support.languages[${index}].phoneNumber` })
  const wathcDescription = useWatch({ control, name: `support.languages[${index}].descriptionStatus` })
  const watchFooter = useWatch({ control, name: `support.languages[${index}].footerDescriptionStatus` })
  const watchPhone = useWatch({ control, name: `support.languages[${index}].phoneStatus` })
  const watchTelefax = useWatch({ control, name: `support.languages[${index}].faxStatus` })
  const watchEmail = useWatch({ control, name: `support.languages[${index}].emailStatus` })

  function renderLanguageForm() {
    return <div style={{ display: 'flex' }}>
      <div style={{ width: '45%', marginRight: 30 }}>
        {/* fix this asap */}
        <FormFields.Input
          label={t('Tooltip')}
          name={`support.languages[${index}].tooltip` as any}
          control={control}
          rules={{
            required: watchSupportStatus ? t('Please enter tooltip') : false,
            maxLength: {
              value: 100,
              message: t('Max char. is 100')
            }
          }}
          placeholder={t('Tooltip')}
        />
        <FormFields.Checkbox
          label={t('Description')}
          control={control}
          defaultValue={0}
          checkboxValue={1}
          name={`support.languages[${index}].descriptionStatus` as any}
        />
        <FormFields.TextArea
          name={`support.languages[${index}].description` as any}
          control={control}
          disabled={!wathcDescription}
          placeholder={t('Description')}
        />
        <FormFields.Checkbox
          label={t('Footer Description')}
          defaultValue={0}
          checkboxValue={1}
          control={control}
          name={`support.languages[${index}].footerDescriptionStatus` as any}
        />
        <FormFields.TextArea
          control={control}
          name={`support.languages[${index}].footerDescription` as any}
          placeholder={t('Footer description')}
          disabled={!watchFooter}
        />
      </div>
      <div style={{ width: '45%' }}>
        <FormFields.Checkbox
          label={t('Phone Number')}
          control={control}
          defaultValue={0}
          checkboxValue={1}
          name={`support.languages[${index}].phoneStatus` as any}
        />
        <Form.Field disabled={!watchPhone}>
          <Input
            value={phoneNumber}
            label={<Dropdown
              options={countriesCodes}
              selectOnBlur={false}
              clearable
              value={watchPhoneCodeField || ''}
              scrolling
              basic
              placeholder={t('Code')}
              onChange={(e, data) => setValue(`support.languages[${index}].phoneCode`, data.value)}
              name={`support.languages[${index}].phoneCode`}
            />}
            onChange={(e, data) => {
              setValue(`support.languages[${index}].phoneNumber`, data.value)
            }}
            labelPosition='left'
            placeholder={watchPhoneCodeField ? t('Phone number') : t('Please select phone code')}
          />
        </Form.Field>
        <FormFields.Checkbox
          label={t('Telefax Number')}
          control={control}
          defaultValue={0}
          checkboxValue={1}
          name={`support.languages[${index}].faxStatus` as any}
        />
        <Form.Field disabled={!watchTelefax}>
          <Input
            value={mobileNumber}
            label={<Dropdown
              scrolling
              basic
              options={countriesCodes}
              selectOnBlur={false}
              value={wathcMobileCodeField}
              onChange={(e, data) => setValue(`support.languages[${index}].faxCode`, data.value)}
              placeholder={t('Code')}
              name={`support.languages[${index}].faxCode`}
            />}
            onChange={(e, data) => setValue(`support.languages[${index}].faxNumber`, data.value)}
            labelPosition='left'
            placeholder={wathcMobileCodeField ? t('Mobile number') : t('Please select mobile code')}
            name={`support.languages[${index}].faxNumber`}
          />
        </Form.Field>
        <FormFields.Checkbox
          label={t('Email')}
          defaultValue={0}
          checkboxValue={1}
          control={control}
          name={`support.languages[${index}].emailStatus` as any}
        />
        <FormFields.Input
          name={`support.languages[${index}].email` as any}
          control={control}
          placeholder={t('Email')}
          rules={{
            pattern: {
              value: emailRegex,
              message: t('Please enter valid email')
            }
          }}
          disabled={!watchEmail}
        />
      </div>
    </div>
  }

  return <>
    {renderLanguageForm()}
  </>
}
export default LanguageForm
